module.exports = {
          srcSet: __webpack_public_path__ + "9b7d78880154c09a8824864dcc0bf714-240.png"+" 240w",
          images:[ {path: __webpack_public_path__ + "9b7d78880154c09a8824864dcc0bf714-240.png",width: 240,height: 16}],
          src: __webpack_public_path__ + "9b7d78880154c09a8824864dcc0bf714-240.png",
          toString:function(){return __webpack_public_path__ + "9b7d78880154c09a8824864dcc0bf714-240.png"},
          
          width: 240,
          height: 16
        }